import React from 'react'
import Slider from "react-slick";
import ChatNow from '../chatnow';

const AreasWeCover = () => {
    const slider = React.useRef(null);

    var settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    };


    return (
        <div className='min-h-screen py-12 relative' id='team'>
            <div className='container mx-auto mb-8' >
                <p className='text-5xl font-bold mt-5 mx-auto px-5'>
                    Our Experienced Team Has Achieved Some Of The Largest Verdicts In The State Of New York
                </p>
                <h2 className='max-w-[700px] mt-5 px-5'>
                    Consectetur We Bring together insurance expertise and the ease of next-gen tech to create policies tailored to the needs of startups and freelancers.
                </h2>
                <div className='py-4 relative'>
                    <button className='absolute z-10 left-4 md:-left-4 top-1/4 md:top-1/2' onClick={() => slider?.current?.slickPrev()} >
                        <img src='/assets/images/arrow-left.png' alt="" className='w-16 h-16' />
                    </button>
                    <div className=''>
                        <Slider {...settings} ref={slider}>
                            <div className='p-4'>
                                <div className='flex flex-col bg-[#F9F9F9]'>                                    <img src='/assets/images/shinichi-araki-lawyer.jpg' alt="" className='w-[100%]' />
                                    <div className='p-5'>
                                        <h3 className='text-3xl font-bold'>
                                            Shinichi Araki
                                        </h3>
                                        <p className='my-12'>HBF Law</p>
                                        <a href='/' className=' flex items-center gap-2' >
                                            <p className='border-b border-black'>Meet Your Lawyer</p>
                                            <img src="/assets/images/arrow-2-right.png" alt='' /></a>
                                    </div>
                                </div>
                            </div>
                            <div className='p-4'>

                                <div className='flex flex-col bg-[#F9F9F9]'>                                    <img src='/assets/images/grace-natalie-lawyer.jpg' alt="" />
                                    <div className='p-5'>
                                        <h3 className='text-3xl font-bold'>
                                            Grace Natalie
                                        </h3>
                                        <p className='my-12'>HBF Law</p>
                                        <a href='/' className=' flex items-center gap-2' >
                                            <p className='border-b border-black'>Meet Your Lawyer</p>
                                            <img src="/assets/images/arrow-2-right.png" alt='' /></a>
                                    </div>
                                </div>
                            </div>
                            <div className='p-4'>
                                <div className='flex flex-col bg-[#F9F9F9]'>                                    <img src='/assets/images/annie-corrine-lawyer.jpg' alt="" />
                                    <div className='p-5'>
                                        <h3 className='text-3xl font-bold'>
                                            Shinichi Araki
                                        </h3>
                                        <p className='my-12'>HBF Law</p>
                                        <a href='/' className=' flex items-center gap-2' >
                                            <p className='border-b border-black'>Meet Your Lawyer</p>
                                            <img src="/assets/images/arrow-2-right.png" alt='' /></a>
                                    </div>
                                </div>
                            </div>
                            <div className='p-4'>
                                <div className='flex flex-col bg-[#F9F9F9]'>
                                    <img src='/assets/images/shinichi-araki-lawyer.jpg' alt="" />
                                    <div className='p-5 w-full'>
                                        <h3 className='text-3xl font-bold'>
                                            Shinichi Araki
                                        </h3>
                                        <p className='my-12'>HBF Law</p>
                                        <a href='/' className=' flex items-center gap-2' >
                                            <p className='border-b border-black'>Meet Your Lawyer</p>
                                            <img src="/assets/images/arrow-2-right.png" alt='' /></a>
                                    </div>
                                </div>

                            </div>
                        </Slider>
                    </div>
                    <button onClick={() => slider?.current?.slickNext()} className='absolute right-4 md:-right-4 top-1/4 md:top-1/2'>
                        <img src='/assets/images/arrow-right.png' alt="" className='w-16 h-16' />
                    </button>

                </div>
            </div>
            <div className='absolute max-sm:left-0 right-0 bottom-2 sm:right-14 p-4'>
                <ChatNow text="Chat now!"/>
            </div>
        </div>
    )
}

export default AreasWeCover